import { Component, Input } from '@angular/core'
import { TemplateLayout } from '../../../types/badge.type'
import { BadgeElement } from '../../../models/badge-variable-elements.model'
import { CommonModule } from '@angular/common'
import { VariableElementComponent } from '../variable-element/variable-element.component'
import { DragDropModule } from '@angular/cdk/drag-drop'
@Component({
  selector: 'app-variable-elements-list',
  templateUrl: './variable-elements-list.component.html',
  styleUrls: ['./variable-elements-list.component.scss'],
  standalone: true,
  imports: [CommonModule, VariableElementComponent, DragDropModule]
})
export class VariableElementsListComponent {
  @Input() public selectedTemplate!: TemplateLayout | null
  @Input() public variableElements!: BadgeElement[]
  @Input() public parentVariableElements!: BadgeElement[]
}
